import React from "react";
import { QRCodeSVG } from "qrcode.react";
import "../styles/TableQRCodes.css";

const TOTAL_TABLES = 50;

export default function TableQRCodes() {
  const baseUrl = window.location.origin;

  return (
    <div className="qr-page">
      {Array.from({ length: TOTAL_TABLES }, (_, i) => i + 1).map((n) => {
        const url = `${baseUrl}/?table=${n}&type=indoor`;
        return (
          <div key={n} className="qr-card">
            <QRCodeSVG value={url} size={200} />
            <p>Table {n}</p>
          </div>
        );
      })}
    </div>
  );
}
